import React, { useState } from "react";
import PropTypes from "prop-types";
import { UID } from "react-uid";
import { parse } from "date-fns";
import Slider from "./Slider";
import Navigation from "./Navigation";
import { eventShape } from "./shapes";

function Timeline({ events }) {
  const [active, setActive] = useState(0);
  const dateFormat = "yyyy-MM-dd HH:mm:ss"; // "1975-01-01 00:00:00"
  events.forEach(
    (event) => (event.dateObj = parse(event.date, dateFormat, new Date()))
  );
  const sortedEvents = events.sort((a, b) => a.dateObj - b.dateObj);

  return (
    <UID name={(id) => `timeline-${id}`}>
      {(id) => (
        <>
          <Navigation
            id={id}
            events={sortedEvents}
            active={active}
            onUpdate={setActive}
          />
          <Slider
            id={id}
            events={sortedEvents}
            active={active}
            onUpdate={setActive}
          />
        </>
      )}
    </UID>
  );
}

Timeline.propTypes = {
  events: PropTypes.arrayOf(PropTypes.exact(eventShape)).isRequired,
};

export default Timeline;
